export const EMOJI_SIZE = 24;
